import $foreign from "./foreign.cjs";
var $$delete = $foreign.delete;
var $$new = $foreign.new;
var peekImpl = $foreign.peekImpl;
var poke = $foreign.poke;
export { $$delete as delete, $$new as new, peekImpl, poke };
